export const getValueList = (editor: any) => {
  const list = editor.children;
  const newList = getParagraph(list);
  return newList;
};

export const getParagraph = (list: { type: string; children: { text: string }[] }[]) => {
  const result: string[] = [];
  list?.forEach((e) => {
    const temp: string[] = [];
    e?.children?.forEach((cl) => {
      if (cl?.text) {
        temp.push(cl.text);
      }
    });
    const str = temp?.join('');
    if (str) {
      const clText = str?.split('\n');
      if (clText?.length) {
        clText.forEach((item) => {
          result.push(item);
        });
      } else {
        result.push(str);
      }
    }
  });
  return result;
};
